// 0 未开通，1 开启 2 关闭 3 审核中 4 审核失败
// http://doc.hunliji.com/workspace/myWorkspace.do?projectId=32#4017
export const PRIVILEGE_STATUS_ACTIVE = 0
export const PRIVILEGE_STATUS_OPEN = 1
export const PRIVILEGE_STATUS_CLOSE = 2
export const PRIVILEGE_STATUS_VERIFYING = 3
export const PRIVILEGE_STATUS_REJECTED = 4

// 商家活动状态
export const MerchantActivityStatus = {
  AUDIT: 1, // 待审核
  SUCCESS: 2, // 通过
  REJECTED: 3 // 拒绝
}
